<template>
  <a-modal
    :title="modalTitTxt"
    :visible="isLimitDialogShow"
    :footer="null"
    :mask-closable="false"
    width="627px"
    :confirm-loading="confirmLoading"
    @cancel="isLimitDialogShow=false"
  >
    <div class="order-info">
      <a-form label-width="100px">
        <a-form-item :label="moneyNumberTit">
          {{ orderData.amount }}
        </a-form-item>
        <a-form-item :label="`${applyTimeTit}：`">
          {{ timestampToTime(orderData.addtime, '-').date }}
          {{ timestampToTime(orderData.addtime, '-').time }}
        </a-form-item>
        <a-form-item :label="invoiveType">
          <template v-if="orderData.type===1">
            {{ $t('message["1563"]') }}
          </template>
          <template v-else>
            {{ $t('message["1562"]') }}
          </template>
        </a-form-item>
        <a-form-item :label="`${headTit}：`">
          {{ orderData.title }}
        </a-form-item>
        <a-form-item :label="`${invoiceConTitTxt}：`">
          <template v-if="orderData.content_type===1">
            {{ $t('message["1363"]') }}
          </template>
          <template v-else>
            {{ $t('message["465"]') }}
          </template>
        </a-form-item>
        <a-form-item :label="`${invoiceTypeTitTxt}：`">
          <template v-if="orderData.sort===1">
            {{ $t('message["237"]') }}
          </template>
          <template v-else>
            {{ $t('message["1605"]') }}
          </template>
        </a-form-item>
        <a-form-item :label="`${receiveTit}：`">
          {{ orderData.consignee }} <template v-if="orderData.sort===2">
            {{ orderData.contact }}
          </template>
        </a-form-item>
        <a-form-item
          v-if="orderData.sort===2"
          :label="`${receiveAdressTit}：`"
        >
          {{ orderData.province }} {{ orderData.city }} {{ orderData.area }} {{ orderData.address }}
        </a-form-item>
        <a-form-item
          v-if="orderData.sort===1"
          :label="`${emailTit}：`"
        >
          {{ orderData.contact }}
        </a-form-item>
        <a-form-item :label="`${orderStatusTit}：`">
          <span
            v-if="orderData.status === 0"
            class="wait-for-pay"
          >{{ $t('message["1049"]') }}</span>
          <template v-else-if="orderData.status === 2">
            {{ $t('message["1455"]') }}
          </template>
          <template v-else>
            {{ $t('message["1455"]') }}
          </template>
        </a-form-item>
        <a-form-item
          v-if="orderData.status === 1"
          :label="`${expressTitTxt}：`"
        >
          {{ express.company }}
          {{ express.number }}
          <i
            id="copyBtn"
            class="icon iconfont icon-copy"
            @click="doCopy"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
import { timestampToTime } from '@/store/account/scripts'
Vue.use(VueClipboard)
export default {
  components: {
  },
  props: {
    orderData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    express () {
      if (Object.keys(this.orderData).length) {
        return this.orderData.express
      }
      return {}
    },
    orderStatusTit () {
      return this.$t('message["250"]')
    },
    invoiveType () {
      return this.$t('message["270"]')
    },
    invoiceConTitTxt () {
      return this.$t('message["271"]')
    },
    modalTitTxt () {
      return this.$t('message["272"]')
    },
    invoiceTypeTitTxt () {
      return this.$t('message["273"]')
    },
    moneyNumberTit () {
      return this.$t('message["526"]')
    },
    expressTitTxt () {
      return this.$t('message["576"]')
    },
    applyTimeTit () {
      return this.$t('message["1042"]')
    },
    receiveAdressTit () {
      return this.$t('message["1105"]')
    },
    headTit () {
      return this.$t('message["1160"]')
    },
    emailTit () {
      return this.$t('message["1505"]')
    },
    receiveTit () {
      return this.$t('message["1104"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    timestampToTime,
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    onCopy () {
      // this.$message({
      //   message: '复制物流运单号成功！',
      //   type: 'success'
      // })
      alert(this.$t('message["325"]'))
    },
    onError () {
      // this.$message.error('复制物流运单号失败！')
      alert(this.$t('message["326"]'))
    },
    doCopy () {
      let that = this
      this.$copyText(this.express.number).then(function (e) {
        alert(that.$t('message["325"]'))
      }, function (e) {
        alert(that.$t('message["326"]'))
      })
    }

  }
}
</script>

<style lang="scss" scoped>
  .order-info::v-deep{
    .ant-row {
        padding-left: 100px;
        .ant-form-item-label {
          float: left;
          width: 90px;
          margin-left: -100px;
          color: #666;
          text-align: right;
        }
        .ant-form-item-control-wrapper {
          float: left;
          width: 100%;
        }
      }
  }
</style>
